























import {Component, Emit, Model, Prop, Vue, Watch} from "vue-property-decorator";
import WardLabel from "@/modules/regions/WardLabel/index.vue";
import {toSlug} from "@/shared/services/helper/utils";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {WardStore} from "@/modules/regionsv2/ward/store";

@Component({
    name: "WardSelectorV2",
    components: {WardLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';


    @Model("change", {type: Number})
    readonly wardId!: number;

    @Emit("change")
    handleChange(value?: number) {
        return value;
    }

    @Prop({required: true})
    readonly districtId!: number;

    get wardIds() {
        return WardStore.mapIdsByDistrictId[this.districtId];
    }

    get wardData() {
        return WardStore.data;
    }

    @Watch("districtId", {immediate: true})
    async onChangeDistrictId(val: number, oldVal: number) {
        if (!val && !oldVal) return;
        if (!val && oldVal) {
            this.handleChange();
            return;
        }
        try {
            await WardStore.listWardsByDistrictV21(val);
            if (!this.wardId) return;
            if (this.wardIds) {
                if (this.wardIds.some((id: number) => id === this.wardId))
                    return;
                else
                    this.handleChange();
            }
        } catch (e) {
            this.$notification.error({
                message: "Thất bại",
                description: e?.response?.data?.message || "Đã có lỗi xảy ra"
            });
        }
    }

    private filterOption(input: string, option: any) {
        return (toSlug(option.componentOptions.children[0].elm.textContent, " ")
                .toLowerCase()
                .indexOf(toSlug(input, " ").toLowerCase()) >= 0);
    }
}
